const getBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  const portStr = port ? `:${port}` : '';
  return `${protocol}//${hostname}${portStr}`;
};

//Local
//export const api = 'http://localhost:8080/api/';

//SERVER
export const api = `${getBaseUrl()}${process.env.BASE_URL}api/app/`;

export const apiSubmit = 'sendVoucher.php';
export const apiCheckPayment = 'getSubsId.php';
export const apiWriteLog = 'waitingLogger.php';
export const apiGetKeyword = 'getKeyword.php';
export const apiWriteLogRedirect = 'urlRotationLogger.php';
